import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import AirportPickupBasicRateServices from "services/AirportPickupBasicRateServices";
import { notifyError, notifySuccess } from "utils/toast";

const useAirportPickupBasicRateSubmit = (id) => {
  
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedVehicleCategory, setSelectedVehicleCategory] = useState(null);
  const [dataInput, setDataInput] = useState([{"vehicle_type_0":"","min_rate_0":"","min_km_0":"","extra_km_0":"","prime_0":""}]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [primeAvailable, setPrimeAvailable] = useState();
  const handleVehicleCategoryChange = (e, index) => {
    const { name,value } = e.target;
    //selected value
    const onChangeVals = [...dataInput];
    onChangeVals[index][name] = value;
    setDataInput(onChangeVals);
    // selected options
    const updatedSelectedOptions = [...selectedOptions];
    updatedSelectedOptions[index] = value;
    setSelectedOptions(updatedSelectedOptions);
  };

  const {
    trigger,
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();
  
  const handleCityChange = (city_id) => {
    setSelectedCity(city_id);
  };

  const handleChangeInput = (e, i) => {
    if(e&&e.target){
    const { name, value } = e.target;
    const onChangeVal = [...dataInput];
    onChangeVal[i][name] = value;
    setDataInput(onChangeVal);
    }
  };
  const onSubmit = async (data) => {
    try {
      const dataValues={};
      const vehicleTypeValues=dataInput.map((item)=> parseInt(item[Object.keys(item)[0]]));

   
      const MinRateValues = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[1]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});
     

      const MinKMValues = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[2]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});

      const ExtraKMValues = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[3]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});
      const PrimeValues = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[4]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});
      dataValues.vehicle_type=vehicleTypeValues;
      dataValues.min_rate=MinRateValues;
      dataValues.min_km=MinKMValues;
      dataValues.extra_km=ExtraKMValues;
      dataValues.prime = PrimeValues;
      dataValues.name_of_airport=selectedCity;
      setIsSubmitting(true);
  
      if (id) {
        const res = await AirportPickupBasicRateServices.updateAirportPickupBasicRate(id,dataValues);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await AirportPickupBasicRateServices.addAirportPickupBasicRate(dataValues);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
     // closeDrawer();
    }
  };

  const getAirportPickupBasicRateData = async () => {
    try {
      const res = await AirportPickupBasicRateServices.getAirportPickupBasicRateById(id);
      if (res) {
        const FormWholeArray=[];
        if(res.vehicle_type_id){
          res.vehicle_type_id.forEach((item,index)=>{
            let obj={};
            obj['vehicle_type_'+index]=item; 
            obj['min_rate_'+index]=res['min_rate'][item]; 
            obj['min_km_'+index]=res['min_km'][item]; 
            obj['extra_km_'+index]=res['extra_km'][item]; 
            obj['prime_'+index]=res['prime'][item]; 
            FormWholeArray.push(obj);
          });
        }
        setDataInput(FormWholeArray);
        setSelectedOptions(res.vehicle_type_id);
        setSelectedCity(res.airport_id);
        setPrimeAvailable(res.prime_available);
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setDataInput([{"vehicle_type_0":"","min_rate_0":"","min_km_0":"","extra_km_0":"","prime_0": ""}]);
      setSelectedOptions([]);
      setSelectedCity(null);     
      clearErrors("name_of_airport");
      clearErrors(); 
  
      return;
    }
      
    if (id) {
      getAirportPickupBasicRateData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    register,
    handleSubmit,
    onSubmit,
    handleCityChange,
    selectedCity,
    trigger,
    errors,
    isSubmitting,
    selectedVehicleCategory,
    setSelectedVehicleCategory,
    handleVehicleCategoryChange,
    selectedOptions,
    setSelectedOptions,
    setDataInput,
    dataInput,
    handleChangeInput,
    primeAvailable
  };
};

export default useAirportPickupBasicRateSubmit;
